import GalleryCarousel from "./gallery-carousel";
import Variants from "./variants";
import HeroProductCarousel from '../hero-product-carousel';

class ProductSinglePre {
  private scope: any;

  constructor() {
    const heroProductCarousel = new HeroProductCarousel();
    heroProductCarousel.init();
    setTimeout(() => {
      heroProductCarousel.carousel?.update();
    }, 2000);

    this.scope = {
      heroProductCarousel: heroProductCarousel,
      variants: new Variants(),
      galleryCarousel: new GalleryCarousel(),
    };
  }

  init() {
    if (!document.querySelector('.l-wishlist')) {
      this.scope.galleryCarousel.init();
    }

    if (!document.querySelector('.o-roomle-iframe') && !document.querySelector('.roomle-iframe-wrapper') && !document.querySelector('.l-wishlist')) {
      this.scope.variants.init(this.scope);
    }
  }
}

export default ProductSinglePre;
